import { render, staticRenderFns } from "./addArea.vue?vue&type=template&id=22c085ba&scoped=true"
import script from "./addArea.vue?vue&type=script&lang=js"
export * from "./addArea.vue?vue&type=script&lang=js"
import style0 from "./addArea.vue?vue&type=style&index=0&id=22c085ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c085ba",
  null
  
)

export default component.exports